import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Flex, ConfigProvider, Result } from 'antd'

const TracerErrorBoundary = ({ children, resetKeys = [] }) => {
  return (
    <ErrorBoundary
      resetKeys={resetKeys}
      fallback={
        <ConfigProvider
          theme={{
            token: {
              colorTextHeading: 'rgb(255, 255, 255)',
              colorTextDescription: 'rgb(255, 255, 255)',
            },
          }}
        >
          <Flex
            vertical={false}
            align="middle"
            style={{ width: '100%', height: '100%' }}
          >
            <Result status="warning" subTitle="Sorry, something went wrong" />
          </Flex>
        </ConfigProvider>
      }
    >
      {children}
    </ErrorBoundary>
  )
}

export default TracerErrorBoundary
